import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { SUPPLIERS_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

type LocationItemType = {
  location: string;
  count: number;
};

type Result = {
  locations: Array<LocationItemType>;
  industries: Array<string>;
  roles: Array<string>;
  categories: Array<string>;
};

type QueryError = {};

type Variables = {
  locations?: string;
  industries?: string;
  categories?: string;
  roles?: string;
  traits?: string;
};

const useJobsSearchFiltersQuery = (
  variables: Variables,
  queryString: string,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${SUPPLIERS_ENDPOINT}/jobs/search/filters`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url, tid, JSON.stringify(variables)];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      const params: any = {
        ...Object.fromEntries(
          Object.entries(variables).filter(([key, value]) => Boolean(value))
        ),
      };

      const res = await fetchWithAuth<Result>(url, {
        params: {
          tid: tid,
          ...params,
        },
        queryString,
      });
      return res;
    },
    {
      enabled: !!tid,
      ...options,
    }
  );
};
export default useJobsSearchFiltersQuery;
